import styled from "styled-components"

export const InputForm = styled.div `
    input {
        width: 100%;
        margin: 5px 0px;
        padding: 21px 15px;
        border-radius: 8px;
        border: 2px solid var(--gray-600);
    }
`